import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { emptyOptionText } from '../utils'

const StatusPill = ({ status }) => {
  const { t } = useTranslation(['visitors'])
  const statusLabels = {
    active: t('visitors:statuses.active'),
    all: t('visitors:statuses.all'),
    banned: t('visitors:statuses.banned'),
    expired: t('visitors:statuses.expired'),
    suspended: t('visitors:statuses.suspended'),
  }
  if (!status) {
    return emptyOptionText
  }

  return (
    <div className={`visitor-status-pill visitor-status-pill--${status}`}>
      {statusLabels[status] ?? status}
    </div>
  )
}

StatusPill.propTypes = {
  status: PropTypes.string,
}

export default StatusPill
